import { LanguageMessage } from './language-message';

/**
 * ç¹ä½ä¸­æè¯­è¨æ¶æ¯
 */
class LanguageMessageForZhft implements LanguageMessage {
  public yes = 'æ¯';
  public no = 'å¦';
  public unsaveNotifyTitle = 'å­å¨æªä¿å­è¨éãæ¯å¦è¦ä¿å­ï¼';
  public clientNotifyTitle = 'åç«¯ç°å¸¸æç¤º';
  public serverNotifyTitle = 'æåå¨ç«¯ç°å¸¸æç¤º';
  public cancelApproveSuccess = 'åæ¶æäº¤æåï¼';
  public cancelApproveFailed = 'åæ¶æäº¤å¤±æï¼';
  public unallowEmptyProcessInstanceName = 'æµç¨å¯¦ä¾åç¨±ä¸è½çºç©º';
  public unallowEmptyBizBillId = 'è«é¸æå£¹æ¢æ¸æ';
  public bizDefKeyRequired = 'å¥å£å®æä¸è½çºç©º';
  public unallowEmptyChildBizBillId = 'å¾è¡¨æ¥­åå®æç·¨èä¸è½çºç©ºï¼';
  public procInsIdRequired = 'æµç¨å¯¦ä¾idä¸è½çºç©ºï¼';
  public addChildFailed = 'æ°å¢å­ç´å¤±æ';
  public addSiblingFailed = 'æ°å¢åç´å¤±æ';
  public addSubChildFailed = 'æ°å¢å¾è¡¨å­ç´å¤±æ';
  public addSubSiblingFailed = 'æ°å¢å¾è¡¨åç´å¤±æ';
  public deleteFailed = 'åªé¤å¤±æ';
  public multiSaveFailed = 'æ¹éä¿å­å¤±æ';
  public appendFailed = 'è¿½å å¤±æ';
  public queryFailed = 'æ¥è©¢å¤±æ';
  public cancelFailed = 'åæ¶å¤±æ';
  public updateFailed = 'æ´æ°å¤±æ';
  public addFailed = 'æ°å¢å¤±æ';
  public loadFailed = 'å è¼å¤±æ';
  public saveSuccess = 'ä¿å­æåï¼';
  public saveFailed = 'ä¿å­å¤±æï¼';
  public deleteSuccess = 'åªé¤æåï¼';
  public deleteFaild = 'åªé¤å¤±æï¼';
  public confirmDeletion = 'ç¢ºèªåªé¤ï¼';
  public submitSuccess = 'æäº¤å¯©æ¹æåï¼';
  public submitFaild = 'æäº¤å¯©æ¹å¤±æï¼';
  public notifyTitle = 'ç³»çµ±æç¤º';
  public httpError = 'HTTPè«æ±é¯èª¤ï¼è«æª¢æ¥Serverç«¯é¯èª¤ï¼';
  public gridDataNotSave = 'ç¶åé æ¸ææªä¿å­ï¼ç¿»é å°å°è´æ¸æä¸å¤±ï¼æ¯å¦ç¹¼çºç¿»é ï¼';
  public exitWithoutSave = 'å­å¨æªä¿å­çæ¸æï¼æ¯å¦ç¹¼çºééï¼';
  public notSupportMenuType = 'ééçæ¢ä¸æ¯èå®ä¹ä¸æ¯æç¨ã';
  public cancelWithoutSave = 'å­å¨æªä¿å­çè®æ´ï¼ç¢ºèªåæ¶ï¼';
  public plsSelectDeleteData = 'è«é¸æè¦åªé¤çæ¸æï¼';
  public errorHierarchyKey = 'é¯èª¤çåç´ç¢¼';
  public plsSelectParentNode = 'è«é¸æç¶ç¯é»';
  public deleteChildFirst = 'è«ååªé¤å­ç¯é»';
  public incorrectHierarchyConfig = 'åç´ç¢¼éç½®ä¿¡æ¯é¯èª¤';
  public operationFailed = 'æä½å·è¡å¤±æã';
  public plsSelectEditData = 'è«é¸æè¦ç·¨è¼¯çæ¸æï¼';
  public plsSelectViewData = 'è«é¸æè¦æ¥ççæ¸æï¼';
  public plsUploadFirst = 'è«åä¸å³éä»¶ï¼';
  public defaultDialogTitle = 'å½çª';
  public changeToFirst = 'å·²å°éç¬¬å£¹æ¢æ¸æ';
  public changeToLast = 'å·²å°éæå¾å£¹æ¢æ¸æ';
  public noProcessInstanceId = 'è«æå®æµç¨å¯¦ä¾æ¨è­ã';
  public noDataExist = 'è¦ç·¨è¼¯çæ¸æä¸å­å¨ï¼ç¡æ³é²å¥ç·¨è¼¯çæï¼';
  public noAttachment = 'æ²æå¯ä»¥é è¦½çéä»¶ã';
  public confirm = 'ç¢ºå®';
  public cancel = 'åæ¶';
  public plsSelectCopyData = 'è«é¸æè¦å¾©å¶çæ¸æï¼';
  public copyFieldsRequired = 'è¦å¾©å¶çå­æ®µä¸è½çºç©ºï¼';
  public pathIsRequired = 'è«æ±è·¯å¾ä¸è½çºç©ºï¼';
  public propsIsEmpty = 'æ²æå¯ä»¥ç·¨è¼¯çç©æç¹å¾ï¼';
  public historyAttachment = 'æå²çæ¬éä»¶ç¦æ­¢åªé¤ï¼';
  public plsSelectDownloadAtt = 'è«é¸æè¦ä¸è¼çéä»¶!';
  public noDownloadAtt = 'æ¾ä¸å°è¦ä¸è¼çéä»¶ï¼';
  public plsCheckBatchEditRows = 'è«å¾é¸è¦æ¹éç·¨è¼¯çè¡ï¼';
  public plsSelectDetailFormData = 'è«åé¸æä¸æ¢å¾è¡¨æ¸æï¼';
  public dataAndStateChanged = 'ç¢ºå®è¦å è¼æ¸æä¸¦åæå°$1çæï¼';
  public dataChanged = 'ç¢ºå®è¦å è¼æ¸æä¸¦æ¾æ£ç¶åä¿®æ¹ï¼';
  public stateChanged = 'ç¢ºå®è¦åæå°$1çæï¼';
  public defaultStateName = 'åå§';
  public copy = 'å¾©å¶è©³ç´°ä¿¡æ¯';
  public copySuccess = 'å¾©å¶æå';
  public copyFailed = 'å¾©å¶å¤±æ';
  public roger = 'ç¥éäº';
  public appOrFuncIdRequired = 'æªéç½®èå®ææç¨åæ¸ï¼è«å¨è¨­è¨å¨ä¸­éç½®ã';
  public tableCanNotEmpty = 'ä¸è½çºç©ºã';
  public plsSelectRemoveAtt = 'è«é¸æè¦åªé¤çéä»¶!';
  public plsSelectUpdateRow = 'è«é¸ææ´æ°éä»¶çè¡ï¼';
  public hasChangeCheckFaild ='å¨æª¢æ¥é é¢æ¯å¦å­å¨æªä¿å­çè®æ´æç¼çé¯èª¤ï¼è«ç¢ºä¿æ¸æå·²ç¶ä¿å­ãæ¯å¦ç¹¼çºééï¼';
  public noParentData = 'è«é¸æä¸ç´æ¸æï¼';
}

export { LanguageMessageForZhft };
